<template>

  <v-main>
    <v-row justify="center" align="center" style="height: 100%;" no-gutters>
        
        <div class="wrapper" elevation-5>

          <v-row v-if="isLoading" no-gutters class="py-12 px-12" justify="center" align="center">
            <v-progress-circular size="32" width="2.5" indeterminate></v-progress-circular>
          </v-row>

          <router-view v-if="!isLoading"></router-view>

        </div>
    </v-row>
  </v-main>

</template>

<script>

import axios from "axios";
import { format, parseISO, addHours, isBefore, isAfter } from 'date-fns';

export default {
    nome: "Principal",
    data: () => ({
      isLoading: true,
    }),
    mounted(){
      const { empID } = this.$route.params;
      if(!empID) alert("Não foi definido o codigo da empresa!");
      if(empID) this.getConfigs();
    },
    methods: {
      redirectToOffline(){
          this.$router.replace({name: 'Offline'});
      },
      async checkAvaliable(horarios){

        const currentDayName = format(new Date(), 'iiii').toLowerCase();

        const currentDay = await horarios.find(day => day.value === currentDayName);

        if(!currentDay || !currentDay.times || currentDay.times.length === 0) return this.redirectToOffline();

        currentDay.times.map(value => {

          let initialDate = parseISO(format(new Date(), 'yyyy-MM-dd')+'T00:00:00');
          let finalDate = parseISO(format(new Date(), 'yyyy-MM-dd')+'T00:00:00');

          let initial = Number(value.initial.time.slice(0, 2));
          let final = Number(value.final.time.slice(0, 2));

          if(value.initial.type === 'pm') initial = initial + 12;

          initialDate = addHours(initialDate, initial);

          if(value.final.type === 'pm') final = final + 12;

          finalDate = addHours(finalDate, final);

          // MAIOR QUE O COMEÇO
          const after = isAfter(new Date(), initialDate);
          const before = isBefore(new Date(), finalDate);

          if(after && before) {
            this.$router.replace({name: 'Signin'});
          }else{
            this.redirectToOffline();
          }

        });
        
      },
      setColors(cores){
        const type = cores.dark ? "dark" : "light";

        if(cores.dark) this.$vuetify.theme.isDark = true;
        this.$vuetify.theme.isDark = true;

        this.$vuetify.theme.themes[type].primary = cores.primaria;
        this.$vuetify.theme.themes[type].secondary = cores.background;
        this.$vuetify.theme.themes[type].texts = cores.textos;
        this.$vuetify.theme.themes[type].btnText = cores.botoes;

      },
      async getConfigs(){
        const { empID } = this.$route.params;

        try {
          const request = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/public/configs/${empID}`);
          const { payload } = request.data;
          this.isLoading = false;
          localStorage.setItem('@bsi:config', JSON.stringify(payload));
          this.setColors(payload.cores);
          this.checkAvaliable(payload.horarios);
        } catch (error) {
          console.log(error);
        }
      }
    }
}
</script>

<style lang="scss">
 
  main{
    background-color: #ccccd4;
    height: 100%;

    .wrapper{

      border-radius: 12px;

      .close{
          position: absolute;
          right: 15px;
          top: 15px;
          opacity: .8;
          transition: all .2s ease-in-out;
          cursor: pointer;
          &:hover{
            opacity: 1;
          }
      }

    }
  }

</style>
